<template>
  <header v-if="!route.path.includes('admin') && DeviceStore.currentMode === 'COMPUTER'" class="navigation-bar pc-nav">
    <a class="brand" href="https://www.twentythree.com.tw/">
      <img :src="require('./assets/img/TwentythreeLogo.svg')" alt="TwoTwentyThree Logo">
    </a>
      
    <nav>
      <ul>
        <li class="color--orange"><a href="https://bit.ly/3uT4gWL">我想販售衣物</a></li>
        <li class="color--orange"><a href="https://www.twentythree.com.tw/categories/sale">優惠活動 SALE</a></li>
        <li class="color--orange"><a href="https://www.twentythree.com.tw/categories/%E6%9C%AC%E9%80%B1%E6%96%B0%E5%93%81-new-arrival">新品 NEW ARRIVAL</a></li>
        <li><a href="https://www.twentythree.com.tw/categories/tops-new">上著 TOPS</a></li>
        <li><a href="https://www.twentythree.com.tw/categories/bottoms-new">下著 BOTTOMS</a></li>
        <li><a href="https://www.twentythree.com.tw/categories/one-piece-new">連身式 ONE-PIECES</a></li>
        <li><a href="https://www.twentythree.com.tw/categories/outers-new">外套/罩衫 OUTERS</a></li>
      </ul>
      <ul>
        <li><img :src="require('./assets/img/icon_search.png')" alt="IconSearch">搜尋</li>
        <li>帳戶</li>
        <li><img :src="require('./assets/img/icon_cart.png')" alt="IconCart"></li>
      </ul>
    </nav>
  </header>

  <header v-if="!route.path.includes('admin') && DeviceStore.currentMode === 'MOBILE'" class="navigation-bar mb-nav">
    <img @click="toggleShowNav" :src="isNavShow ? require('./assets/img/icon_close.svg') :require('./assets/img/icon_index.svg')" alt="">

    <a class="brand" href="https://www.twentythree.com.tw/">
      <img :src="require('./assets/img/TwentythreeLogo.svg')" alt="TwoTwentyThree Logo">
    </a>

    <img :src="require('./assets/img/icon_cart.png')" alt="IconCart">
      
    <nav :class="isNavShow ? null : 'hide'">
      <ul>
        <li class="member-and-contact">
          <div><a href="https://www.twentythree.com.tw/users/sign_in">會員登入/新用戶註冊</a></div>
          <div><a href="https://m.me/113940290252039?ref=fq-E6QRMfv">聯絡我們</a></div>
        </li>
        <li><b>目錄</b></li>
        <li class="color--lightBlue"><a href="https://bit.ly/3uT4gWL">我想販售衣物</a></li>
        <li class="color--lightBlue"><a href="https://www.twentythree.com.tw/categories/sale">優惠活動 SALE</a></li>
        <li><a href="https://www.twentythree.com.tw/categories/%E6%9C%AC%E9%80%B1%E6%96%B0%E5%93%81-new-arrival">新品 NEW ARRIVAL</a></li>
        <li><a href="https://www.twentythree.com.tw/categories/tops-new">上著 TOPS</a></li>
        <li><a href="https://www.twentythree.com.tw/categories/bottoms-new">下著 BOTTOMS</a></li>
        <li><a href="https://www.twentythree.com.tw/categories/one-piece-new">連身式 ONE-PIECES</a></li>
        <li><a href="https://www.twentythree.com.tw/categories/outers-new">外套/罩衫 OUTERS</a></li>
      </ul>
    </nav>
  </header>
  <router-view/>
</template>

<script>
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useDeviceStore } from './stores/device';

export default {
  setup() {
    const route = useRoute()
    console.log(route.path.includes('admin'))
    const DeviceStore = useDeviceStore()
    const windowWidth = ref(window.innerWidth)
    const onWidthChange = () => windowWidth.value = window.innerWidth

    onMounted(() => window.addEventListener('resize', onWidthChange))
    onUnmounted(() => window.removeEventListener('resize', onWidthChange))

    watch(windowWidth,(newValue) => {
      if(newValue < 550) { DeviceStore.changeMode('MOBILE'); return }
      if (newValue >= 550 && newValue < 1200) { DeviceStore.changeMode('TABLET'); return }
      DeviceStore.changeMode('COMPUTER')
    }, { immediate:true })

    const isNavShow = ref(false)
    const toggleShowNav = () => isNavShow.value = !isNavShow.value

    return {
      route,
      DeviceStore,
      windowWidth,
      isNavShow,
      onWidthChange,
      toggleShowNav,
    }
  }
}
</script>
